import { useTheme } from "@/theme/ThemeProvider";
import { Stack } from "expo-router";

export default function ConfigLayout() {
  const { theme } = useTheme();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: {
          backgroundColor: theme.color.bg,
        },
      }}
    />
  );
}
